import {services} from "../../data/status";
// import "./SystemStatusPage.css";


const SystemStatusPage=()=>{


return (

<section className="status-page">


<div className="status-header">

<h1>
System Status
</h1>

<p>
Current operational status of Magyne services.
</p>

</div>


<div className="status-card">

{
services.map(service=>(

<div className="service"
key={service.name}>


<div>

<h3>
{service.name}
</h3>


<p>
{service.status}
</p>

</div>


<span className="online">
●
</span>


</div>

))
}

</div>


</section>

)

}


export default SystemStatusPage;